import { render, staticRenderFns } from "./refPropCard.vue?vue&type=template&id=1db34ef1"
import script from "./refPropCard.vue?vue&type=script&lang=js"
export * from "./refPropCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports